import Vue from 'vue';

export const GlobalModule = {
  state: {
    /**
     * My bets
     */
    mybets: [],
    /**
     * Agent multiView Screen
     */
    AgentMultiView: false,
    /**
     * Agent id of the last selected match (event)
     */
    AgentActiveMatchId: 0,
    isMobile: process.env.VUE_APP_IS_AGENT && window.innerWidth < 993,
    keyboardShortcuts: {},
    showMoreOdds: {},
  },
  mutations: {
    addMyBets(state, payload) {
      Vue.set(state, 'mybets', payload);
    },
    setMultiView(state, payload) {
      Vue.set(state, 'AgentMultiView', payload);
    },
    setActiveMatchId(state, payload) {
      Vue.set(state, 'AgentActiveMatchId', payload);
    },
    screenResized(state) {
      state.isMobile = process.env.VUE_APP_IS_AGENT && window.innerWidth < 993;
    },
    addKeyboardShortcuts(state, shortcuts) {
      state.keyboardShortcuts = shortcuts;
    },
    toggleOddsDisplay(state, idx) {
      state.showMoreOdds[idx] = !state.showMoreOdds[idx];
      state.showMoreOdds = Object.assign({}, state.showMoreOdds);
    },
  },
  getters: {
    cashoutNumBetsTotal(state) {
      return state.mybets.length;
    }
  },
};
